"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateId = void 0;
/**
 * Generates a certification watermark id from a given prefix id and an optional postfix id.
 * @param prefix - The prefix id.
 * @param postfix - The optional postfix of the id.
 */
function generateId(prefix, postfix) {
    var id = prefix;
    if (postfix) {
        id += '-' + postfix;
    }
    return id;
}
exports.generateId = generateId;
//# sourceMappingURL=Id.js.map